/* eslint-disable */
import React from 'react';
import styled, { css } from 'styled-components';
import { useTable, useSortBy } from 'react-table';
import { Link } from 'react-router-dom';
// import { Scrollbars } from 'react-custom-scrollbars';

import { SortBy } from '../../assets/SortBy';
import { Caret } from '../../assets/Caret';

const StyledTable = styled.table`
  width: 100%;
  /* margin-top: 24px; */

  thead {
    tr {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1fr;
      justify-items: start;

      padding: 16px 0;

      border-top: 1px solid;
      border-bottom: 1px solid;
      border-color: ${props => props.theme.bg4};

      th {
        display: flex;
        align-items: center;
        gap: 6px;

        color: ${props => props.theme.text2};
        font-weight: 400;
        font-size: 12px;

        user-select: none;
      }
    }
  }
`;

const Staked = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;

  height: 100%;

  h6 {
    margin: 0;

    font-family: Bebas Neue;
    font-size: 20px;
    font-weight: 600;
  }

  strong {
    display: flex;
    align-items: center;

    margin-right: 6px;

    color: ${props => props.theme.accent0};
    font-size: 12px;
    font-weight: 500;

    svg path {
      fill: ${props => props.theme.accent0};
    }
  }
`;

const Asset = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  height: 100%;
`;

const AssetIcon = styled.img`
  width: 24px;
  height: 24px;

  border-radius: 50%;
`;

const Validator = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const ValidatorPoster = styled.div`
  display: flex;
  align-items: center;

  position: relative;

  border-radius: 4px;
  overflow: hidden;
`;

const ValidatorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span {
    font-size: 12px;
    font-weight: 500;
    color: ${props => props.theme.text2};
  }

  strong {
    font-size: 16px;
    font-weight: 500;
    color: ${props => props.theme.text0};
  }
`;

const ValidatorRow = styled.tr`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;

  margin-top: 20px;

  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

const sortedMixin = css`
  .arrow-up {
    fill: ${props => (props.sortedDesc ? props.theme.text2 : props.theme.text0)};
  }

  .arrow-down {
    fill: ${props => (props.sortedDesc ? props.theme.text0 : props.theme.text2)};
  }
`;

const SortIconWrapper = styled.span`
  height: 16px;

  font-size: 0;
  svg path {
    fill: ${props => props.theme.text2};
  }

  ${props => (props.sorted ? sortedMixin : '')};
`;

const APR = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  height: 100%;

  font-weight: 500;
  color: ${props => props.theme.accent0};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

const data = [
  {
    actions: {
      id: '0',
    },
    name: {
      name: 'Coinbase Custody',
      imageSrc: 'https://picsum.photos/64/72',
      votingPower: '13.9M',
    },
    staked: {
      number: 14210.51,
      change: 33.2,
    },
    fee: 7.5,
    // assets: {
    //   iconSrc: 'https://picsum.photos/24/24',
    //   code: 'XRP',
    // },
    apr: 3.54,
  },
  {
    actions: {
      id: '2',
    },
    name: {
      name: 'Binance Staking',
      imageSrc: 'https://picsum.photos/64/72',
      votingPower: '13.9M',
    },
    staked: {
      number: 8881.88,
      change: 125.2,
    },
    fee: 2,
    // assets: {
    //   iconSrc: 'https://picsum.photos/24/24',
    //   code: 'USDT',
    // },
    apr: 9.54,
  },
];

const columns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: ({ value }) => (
      <Validator>
        <ValidatorPoster>
          <img src={value.imageSrc} alt="" />
        </ValidatorPoster>
        <ValidatorInfo>
          <strong>{value.name}</strong>
          <span>{value.votingPower} Voting Power</span>
        </ValidatorInfo>
      </Validator>
    ),
  },
  {
    Header: 'Staked',
    accessor: 'staked',
    Cell: ({ value }) => (
      <Staked>
        <h6>{value.number}</h6>

        <strong>
          {value.change} <Caret />
        </strong>
      </Staked>
    ),
  },
  // {
  //   Header: 'Assets',
  //   accessor: 'assets',
  //   Cell: ({ value }) => (
  //     <Asset>
  //       <AssetIcon src={value.iconSrc} alt="" />
  //       {value.code}
  //     </Asset>
  //   ),
  // },
  {
    Header: 'Fee',
    accessor: 'fee',
    Cell: ({ value }) => <Asset>{value}%</Asset>,
  },
  {
    Header: 'APR',
    accessor: 'apr',
    Cell: ({ value }) => <APR>{value}%</APR>,
  },
];

export default function StakingTable() {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  return (
    <StyledTable {...getTableProps()}>
      <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {!column.disableSortBy && (
                  <SortIconWrapper sorted={column.isSorted} sortedDesc={column.isSortedDesc}>
                    <SortBy />
                  </SortIconWrapper>
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>

      {/* <Scrollbars style={{ height: 500, width: 'auto' }}> */}
      <tbody {...getTableBodyProps()}>
        {rows.map(row => {
          prepareRow(row);

          return (
            <StyledLink to={row.id}>
              <ValidatorRow {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </ValidatorRow>
            </StyledLink>
          );
        })}
      </tbody>
      {/* </Scrollbars> */}
    </StyledTable>
  );
}
